import { Component } from '@angular/core';

@Component({
  selector: 'app-score-registration-link',
  templateUrl: './score-registration-link.component.html',
  styleUrls: ['./score-registration-link.component.scss']
})
export class ScoreRegistrationLinkComponent {

}
